export type LegendItem = {
  color: string;
  label: string;
};

export const STATE_TIV_COLOR_SCALE = [
  "#f7fbff",
  "#deebf7",
  "#c6dbef",
  "#9ecae1",
  "#4292c6",
  "#2171b5",
  "#08519c",
  "#08306b",
] as const;

export const STATE_TIV_PERCENTILE_BOUNDARIES = [0, 12.5, 25, 37.5, 50, 62.5, 75, 87.5, 100] as const;

export const STATE_TIV_LEGEND_ITEMS: LegendItem[] = STATE_TIV_COLOR_SCALE.map((color, index) => {
  const lower = STATE_TIV_PERCENTILE_BOUNDARIES[index];
  const upper = index < STATE_TIV_PERCENTILE_BOUNDARIES.length - 1 ? STATE_TIV_PERCENTILE_BOUNDARIES[index + 1] : 100;
  return {
    color,
    label: `${lower}–${upper}% Percentile`,
  };
});

// Every other legend is defined once in python-libs/pingutils/pingintel/legends/layer_legends.json and generated into
// legend-items.generated.ts by `python bin/generate_layer_legends.py`. Edit the JSON, not the generated file.
export * from "./legend-items.generated";
